import cx from 'classnames';
import styles from './SidePanel.module.less';
import ReportCustomizationPanel from './ReportCustomizationPanel';
import ReportFormatSelection from './ReportFormatSelection';
import ReportCategorySelection from './ReportCategorySelection';
import ReportDistributionPanel from './ReportDistributionPanel';

const SidePanel = () => (
  <div className={cx(styles.reportSidebarPanel, 'panel')}>
    <ReportCategorySelection />
    <ReportFormatSelection />
    <ReportCustomizationPanel />
    <ReportDistributionPanel />
  </div>
);

export default SidePanel;
